import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Search, X } from 'lucide-react';
import type { DeletionRequestStatus } from '@/types';

export interface DeletionRequestFiltersState {
  search?: string;
  status?: DeletionRequestStatus;
}

interface DeletionRequestFiltersProps {
  filters: DeletionRequestFiltersState;
  onFiltersChange: (filters: DeletionRequestFiltersState) => void;
}

export function DeletionRequestFilters({ filters, onFiltersChange }: DeletionRequestFiltersProps) {
  const handleSearchChange = (value: string) => {
    onFiltersChange({ ...filters, search: value || undefined });
  };

  const handleStatusChange = (value: string) => {
    onFiltersChange({
      ...filters,
      status: value === 'all' ? undefined : (value as DeletionRequestStatus),
    });
  };

  const clearFilters = () => {
    onFiltersChange({});
  };

  const hasFilters = filters.search || filters.status;

  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="relative min-w-[200px] flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search by name or email..."
          value={filters.search || ''}
          onChange={(e) => handleSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>

      <Select value={filters.status || 'all'} onValueChange={handleStatusChange}>
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="All Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="archived">Archived</SelectItem>
          <SelectItem value="deleted">Deleted</SelectItem>
          <SelectItem value="cancelled">Cancelled</SelectItem>
          <SelectItem value="restored">Restored</SelectItem>
        </SelectContent>
      </Select>

      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={clearFilters}>
          <X className="mr-2 h-4 w-4" />
          Clear
        </Button>
      )}
    </div>
  );
}
